import { TICK_STATES } from "@swiggy-private/payment-ui";

export enum TEXT_TYPES {
    MAIN = "main",
    SUB = "sub",
    INTERMEDIATE = "intermediate",
}

export const ORDER_CONFIRM_LOADING_TEXT = "Hold On!";
export const ORDER_CONFIRM_LOADING_SUB_TEXT = "We are verifying your payment status.";

export const SUCCESS_TEXT = {
    CARD_SECURED: "Card was secured successfully!",
    CARD_SAVED: "Card saved successfully!",
};

export const DEFAULT_TICK_STATE = {
    [TICK_STATES.LOADING]: {
        [TEXT_TYPES.MAIN]: "Hold On!",
        [TEXT_TYPES.SUB]: "We are verifying your payment status.",
    },
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Yay! Order Received",
        [TEXT_TYPES.SUB]: "Your order will be delivered shortly. Keep Swiggying!",
    },
};

export const INSTAMART_TICK_STATE = {
    [TICK_STATES.LOADING]: DEFAULT_TICK_STATE[TICK_STATES.LOADING],
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Yay! Order Received",
        [TEXT_TYPES.SUB]: "Your order will be delivered shortly. Keep exploring great deals on Instamart!",
    },
};

export const JUST_TICK_STATE = {
    [TICK_STATES.LOADING]: DEFAULT_TICK_STATE[TICK_STATES.LOADING],
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Yay! Order Received",
        [TEXT_TYPES.SUB]: "Your order will be delivered shortly. Keep exploring great deals on Jus+!",
    },
};

export const DEFAULT_TOING_TICK_STATE = {
    [TICK_STATES.LOADING]: DEFAULT_TICK_STATE[TICK_STATES.LOADING],
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Yay! Order Received",
        [TEXT_TYPES.SUB]: "Your order will be delivered shortly. Keep Toing!",
    },
};

export const DINEOUT_TICK_STATE = {
    [TICK_STATES.LOADING]: DEFAULT_TICK_STATE[TICK_STATES.LOADING],
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Payment Successful!",
        [TEXT_TYPES.SUB]: "",
    },
};

export const DINEOUT_STEAL_DEAL_TICK_STATE = {
    [TICK_STATES.LOADING]: DEFAULT_TICK_STATE[TICK_STATES.LOADING],
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Voucher purchase successful !",
        [TEXT_TYPES.SUB]: "",
    },
};

export const SUPER_TICK_STATE = {
    [TICK_STATES.LOADING]: DEFAULT_TICK_STATE[TICK_STATES.LOADING],
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Yay! Plan Purchased",
        [TEXT_TYPES.SUB]: "",
    },
};

export const POST_ORDER_TIPPING_TICK_STATE = {
    [TICK_STATES.LOADING]: DEFAULT_TICK_STATE[TICK_STATES.LOADING],
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "",
        [TEXT_TYPES.SUB]: "",
    },
};

export const PENNY_DROP_TICK_STATE = {
    [TICK_STATES.LOADING]: DEFAULT_TICK_STATE[TICK_STATES.LOADING],
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "",
        [TEXT_TYPES.SUB]: "",
    },
};

export const SWIGGY_MONEY_TICK_STATE = {
    [TICK_STATES.LOADING]: {
        [TEXT_TYPES.MAIN]: "Hold On!",
        [TEXT_TYPES.SUB]: "checking the add money status...",
    },
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Money added successfully",
        [TEXT_TYPES.SUB]: "redirecting to complete the order...",
    },
};

export const POST_ORDER_PRIORITY_DELIVERY_STATE = {
    [TICK_STATES.LOADING]: DEFAULT_TICK_STATE[TICK_STATES.LOADING],
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Sit tight!",
        [TEXT_TYPES.SUB]: "",
        [TEXT_TYPES.INTERMEDIATE]: "Your order will be delivered on priority",
    },
};

export const ASSURE_PAY_ALL_DUES_TICK_STATE = {
    [TICK_STATES.LOADING]: {
        [TEXT_TYPES.MAIN]: "Hold On!",
        [TEXT_TYPES.SUB]: "We are verifying your payment status.",
    },
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Payment Successful!",
        [TEXT_TYPES.SUB]: "Your credit limit has been restored",
    },
};

export interface ConfirmOrderTextsPayload {
    businessLine?: string;
    tickState: TICK_STATES;
    isPostOrderTip?: boolean;
    isPriorityDelivery?: boolean;
    isToing?: boolean;
    isPennyDrop?: boolean;
    successDataInfo?: {
        main?: string;
        sub?: string;
    };
    isPrebookPrepaidCart?: boolean;
}

export const PAY_ON_DELIVERY_TICK_STATE = {
    [TICK_STATES.LOADING]: {
        [TEXT_TYPES.MAIN]: "Hold On!",
        [TEXT_TYPES.SUB]: "We are verifying your payment status.",
    },
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Yay! Payment Received",
        [TEXT_TYPES.SUB]: "Keep Swiggying",
    },
};

export const PAY_ON_DELIVERY_TOING_TICK_STATE = {
    [TICK_STATES.LOADING]: PAY_ON_DELIVERY_TICK_STATE[TICK_STATES.LOADING],
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Yay! Payment Received",
        [TEXT_TYPES.SUB]: "Keep Toing",
    },
};

export const SWIGGY_MONEY_GENERIC_TICK_STATE = {
    [TICK_STATES.LOADING]: {
        [TEXT_TYPES.MAIN]: "Hold On!",
        [TEXT_TYPES.SUB]: "checking the add money status...",
    },
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Money added successfully",
        [TEXT_TYPES.SUB]: "",
    },
};

export const SWIGGY_MONEY_GENERIC_TICK_STATE_GIFT = {
    [TICK_STATES.LOADING]: {
        [TEXT_TYPES.MAIN]: "Hold On!",
        [TEXT_TYPES.SUB]: "We are verifying your payment status.",
    },
    [TICK_STATES.SUCCESS]: {
        [TEXT_TYPES.MAIN]: "Yay! Gift card created!",
        [TEXT_TYPES.SUB]: "",
    },
};

export const IM_ORDER_PLACED_TRANSITION_LOTTIE_ASSET_ID = "IM-PD-Assets/TrackingScreen/orderplaced%20IM.json";
